import { TransactionStatus } from '@portal/enum/approvalsType';
import RolesType from '@portal/enum/rolesType';
import { TransactionType } from '@portal/models/enumerators';
import { translate } from '@portal/services/i18n';

export const validationStatus = (status: TransactionStatus) => {
  if (status === TransactionStatus.PENDING_APPROVE) {
    return translate(
      'PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.PENDING_APPROVE'
    );
  }
  if (status === TransactionStatus.PENDING_CONFIRM) {
    return translate(
      'PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.PENDING_CONFIRM'
    );
  }
  if (status === TransactionStatus.EXECUTED) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.EXECUTED');
  }
  if (status === TransactionStatus.FAILED) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.FAILED');
  }
  if (status === TransactionStatus.REVERSAL) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.REVERSAL');
  }
  if (status === TransactionStatus.REPROVED) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.REPROVED');
  }
  if (status === TransactionStatus.PENDING_CREATE) {
    return translate(
      'PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.PENDING_CREATE'
    );
  }
  if (status === TransactionStatus.EXPIRED) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.EXPIRED');
  }
  if (status === TransactionStatus.SCHEDULE) {
    return translate('PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.SCHEDULE');
  }
  if (status === TransactionStatus.CANCELLED) {
    return translate(
      'PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.CANCELLED'
    );
  }
};

export const getLimitFlowPermissions = (flow: TransactionType) => {
  const flowPermissions = {
    [TransactionType.P2P]: {
      read: [RolesType.READ_TEF_LIMIT, RolesType.MANAGE_TEF_LIMIT],
      write: [RolesType.MANAGE_TEF_LIMIT],
    },
    [TransactionType.TED]: {
      read: [RolesType.READ_TED_LIMIT, RolesType.MANAGE_TED_LIMIT],
      write: [RolesType.MANAGE_TED_LIMIT],
    },
    [TransactionType.BILLET]: {
      read: [RolesType.READ_BILLET_LIMIT, RolesType.MANAGE_BILLET_LIMIT],
      write: [RolesType.MANAGE_BILLET_LIMIT],
    },
    [TransactionType.PIX]: {
      read: [RolesType.READ_PIX_LIMIT, RolesType.MANAGE_PIX_LIMIT],
      write: [RolesType.MANAGE_PIX_LIMIT],
    },
    [TransactionType.API_GATEWAY_PIX]: {
      read: [
        RolesType.READ_API_GATEWAY_PIX_LIMIT,
        RolesType.MANAGE_API_GATEWAY_PIX_LIMIT,
      ],
      write: [RolesType.MANAGE_API_GATEWAY_PIX_LIMIT],
    },
  };

  return flowPermissions[flow];
};
